"use client";

import React, { useRef, useState, useEffect } from "react";
import { Tooltip } from "../tooltip/Tooltip";

interface ProductNameWithTooltipProps {
  name: string;
  className?: string;
}

export const ProductNameWithTooltip = ({
  name,
  className = "",
}: ProductNameWithTooltipProps) => {
  const visibleRef = useRef<HTMLDivElement>(null);
  const measureRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const visible = visibleRef.current;
    const measure = measureRef.current;
    let observer: ResizeObserver | null = null;

    if (visible && measure) {
      const checkTruncation = () => {
        if (!visibleRef.current || !measureRef.current) return;
        const vis = visibleRef.current;
        const meas = measureRef.current;
        const visibleHeight = vis.clientHeight;
        const naturalHeight = meas.offsetHeight;
        setIsTruncated(naturalHeight > visibleHeight);
      };

      checkTruncation();
      observer = new ResizeObserver(checkTruncation);
      observer.observe(visible);
    }

    return () => observer?.disconnect();
  }, [name]);

  const formattedName =
    name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();

  const visibleElement = (
    <div
      ref={visibleRef}
      className={`line-clamp-2 font-bold text-[1.1em] ${className}`}
    >
      {formattedName}
    </div>
  );

  return (
    <div className="relative w-full min-w-0">
      <div
        ref={measureRef}
        aria-hidden
        className={`absolute left-0 top-0 right-0 font-bold text-[1.1em] opacity-0 pointer-events-none invisible whitespace-normal ${className}`}
        style={{ zIndex: -1 }}
      >
        {formattedName}
      </div>
      {isTruncated ? (
        <Tooltip text={formattedName}>{visibleElement}</Tooltip>
      ) : (
        visibleElement
      )}
    </div>
  );
}
